import { useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import StatsSVG from "./stats.svg";
import AstrolineLogo from "./astroline-logo.svg";
import Logo008 from "./008-logo.svg"; // Importación del nuevo logo
import LoginService from "../../services/login-service";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [userName, setUsername] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isEmailValid, setIsEmailValid] = useState(true); // Nuevo estado para validar email
  const [shakeUsername, setShakeUsername] = useState(false);
  const [shakePassword, setShakePassword] = useState(false);

  const currentDomain = window.location.hostname;
  const is008Agent = currentDomain.endsWith("008agent.ai");

  const handleLogin = () => {
    setError(""); // Reinicia el error global

    if (!userName && !password) {
      // Ambos campos vacíos
      triggerShake(setShakeUsername);
      triggerShake(setShakePassword);
      setError("Username and Password are required.");
      return;
    }

    if (!userName) {
      // Solo el username está vacío
      triggerShake(setShakeUsername);
      setError("Username and Password are required.");
      return;
    }

    if (!password) {
      // Solo el password está vacío
      triggerShake(setShakePassword);
      setError("Username and Password are required.");
      return;
    }

    if (!isEmailValid) {
      // Ambos campos están llenos pero el email no es válido
      triggerShake(setShakeUsername);
      setError("Please enter a valid email address.");
      return;
    }

    // Si no hay errores, continuar
    setError(""); // Asegúrate de que no quede ningún error global

    setLoading(true);

    LoginService.login(userName, password)
      .then(({ data }) => {
        localStorage.setItem("krakenT", data?.accessToken || "");
        localStorage.setItem("CL", data?.companyLogo);
        localStorage.setItem("UN", data?.name);
        localStorage.setItem("CN", data?.companyName);
        localStorage.setItem("EMAIL", userName);

        setLoading(false);
        navigate(`/`);
      })
      .catch(() => {
        setError("Invalid username or password. Please try again.");
        triggerShake(setShakeUsername);
        triggerShake(setShakePassword);
        setLoading(false);
      });
  };

  const triggerShake = (setShake) => {
    setShake(true);
    setTimeout(() => setShake(false), 500); // Resetear shake después de 500ms
  };

  const handleUsernameChange = (value) => {
    setUsername(value);
    setIsEmailValid(validateEmail(value)); // Validar el email mientras el usuario escribe
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular para validar email
    return emailRegex.test(email);
  };
  return (
    <>
      <div className="h-screen">
        <div className="group max-w-7xl space-y-12 p-8 mx-auto h-screen items-center justify-center flex flex-col">
          {!is008Agent && (
            <img
              src={AstrolineLogo}
              className="self-center h-auto w-48"
              height="100"
              width="100"
              alt="Stats icon"
            />
          )}
          <div className=" bg-white p-8 ring-1 ring-gray-200 rounded-xl h-fit lg:w-[460px] max-w-[460px] flex flex-col items-center justify-center space-y-4">
            <div className="group-hover:shadow-main flex flex-col items-center justify-center gap-3 bg-gray-100/60 p-4 rounded-xl ">
              <img
                src={is008Agent ? Logo008 : StatsSVG}
                className="self-center h-auto w-14"
                height="40"
                width="40"
                alt="Stats icon"
              />
            </div>
            <p className="text-xl">Insights</p>

            <p className="font-extralight text-sm text-center">
              Explore detailed analytics and powerful tools designed to optimize
              enhance the efficiency of your calls.
            </p>

            <div className="w-full space-y-4 pt-8">
              <div className={`space-y-2 ${shakeUsername ? "shake" : ""}`}>
                <input
                  type="text"
                  placeholder="Username"
                  className={`w-full px-4 py-3 rounded-lg ring-1 transition-all ${
                    !isEmailValid || (error && !userName)
                      ? "ring-red-300"
                      : "ring-gray-200"
                  } focus:ring-2 ${
                    is008Agent ? "focus:ring-[#F02F65]" : "focus:ring-main"
                  } focus:border-transparent outline-none`}
                  value={userName}
                  onChange={(e) => handleUsernameChange(e.target.value)}
                />
              </div>

              <div className={`relative ${shakePassword ? "shake" : ""}`}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className={`w-full px-4 py-3 rounded-lg ring-1 transition-all ${
                    error && !password ? "ring-red-300" : "ring-gray-200"
                  } focus:ring-2 ${
                    is008Agent ? "focus:ring-[#F02F65]" : "focus:ring-main"
                  } focus:border-transparent outline-none`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? (
                    <EyeSlashIcon className="text-gray-200 h-6" />
                  ) : (
                    <EyeIcon className="text-gray-200 h-6" />
                  )}
                </button>
              </div>
            </div>
            <button
              onClick={() => handleLogin()}
              disabled={loading}
              className={`rounded-xl w-full h-12 flex items-center justify-center ${
                loading
                  ? "bg-gray-300 cursor-not-allowed"
                  : `${
                      is008Agent
                        ? "bg-[#F02F65] hover:bg-#F02F65]/90"
                        : "bg-main hover:bg-main/90"
                    }`
              } transition-all ease-in-out duration-300 text-white`}
            >
              {loading ? (
                <>
                  <div
                    class="inline-block h-5 w-5 mr-2 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                    role="status"
                  >
                    <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                      Loading...
                    </span>
                  </div>{" "}
                  Logging in...
                </>
              ) : (
                "Login"
              )}
            </button>

            {error && <a className="text-sm text-red-500">{error}</a>}
            <div className="flex gap-1 text-sm items-center pt-4">
              <p className="font-extralight">Forgot password?</p>
              <a
                href={`${
                  is008Agent
                    ? "https://www.008agent.ai/es/contact"
                    : "https://www.astroline.com/vooster/microsoft-teams/operator-connect"
                }`}
                target="_blank"
                rel="noopener noreferrer"
                className={`font-regular ${
                  is008Agent ? "text-[#F02F65]" : "text-main"
                } hover:underline`}
              >
                Contact us!
              </a>
            </div>
          </div>
        </div>

        <div className="text-gray-400 absolute gap-4 items-center justify-center bottom-0 left-1/2 transform -translate-x-1/2 p-4 flex">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.astroline.com/politicas/"
            className={`font-extralight text-xs ${
              is008Agent ? "text-[#F02F65]" : "text-main"
            }`}
          >
            Legal Notice
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.astroline.com/politicas/"
            className={`font-extralight text-xs ${
              is008Agent ? "text-[#F02F65]" : "text-main"
            }`}
          >
            Privacy Policy
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.astroline.com/"
            className={`font-extralight text-xs ${
              is008Agent ? "text-[#F02F65]" : "text-main"
            }`}
          >
            Astroline Web
          </a>
        </div>
      </div>
    </>
  );
}
